import React, { forwardRef, useImperativeHandle, useState } from "react";
import { Button, Form, Modal } from "antd";
import { PaperClipOutlined } from "@ant-design/icons";
import { t } from "i18next";
import axios from "axios";
import { Util } from "common/util";
import { getURl, getHostURl } from "services/core";
import { createAndUpdateSalaryScaleRow } from "services/salary_scale_record";
import Dragger from "antd/lib/upload/Dragger";



function AttachmentModal({ datas }, ref) {
  const [visible, setVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [attachmes, setAttachmes] = useState([]);
  const [salaryScaleRecord, setSalaryScaleRecord] = useState({});
  const [form] = Form.useForm()

  useImperativeHandle(ref, () => {
    return {
      showAttachmentModal(record) {
        setVisible(true)
        setSalaryScaleRecord(record)
      }
    };
  }, []);

  const onCancel = () => {
    setVisible(false);
    setLoading(false);
    setAttachmes([]);
    form.resetFields();
    setSalaryScaleRecord({});
  }

  const onUploadFile = (options) => {
    const { onSuccess, file } = options;
    const formData = new FormData();
    const config = {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${Util.getInstance().getAccessToken()}`,
      },
    };
    formData.append("attachment", file, file.name);
    axios
      .post(`${getURl()}/file/v1/salary_scale/attachment?salaryScaleEntryId=${salaryScaleRecord.salaryScaleId}`, formData, config)
      .then((response) => {
        onSuccess("Ok");
        const file = {
          uid: Date.now(),
          name: response.data.originalname,
          destination: response.data.destination,
          status: "done",
          url: `${getHostURl()}/${response.data.path}`,
        };
        setAttachmes([{ ...file }])
      })

  };

  const onRemoveFile = (file) => {
    axios({
      method: "DELETE",
      url: `${getURl()}/file/v1/file/delete?path=${file.destination}/${file.name}`,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${Util.getInstance().getAccessToken()}`,
      },
    })
      .then(() => {
        form.setFieldsValue({
          attachment: undefined
        })
        setAttachmes([]);
      });

  }

  const onFinish = (values) => {
    salaryScaleRecord["attachment"] = attachmes[0]["name"];
    setLoading(true)
    delete salaryScaleRecord["new"]
    createAndUpdateSalaryScaleRow(salaryScaleRecord).then(() => {
      datas.fetchData(datas.data.year);
      datas.setPresalaryScales([]);
      onCancel();
    }).finally(() => setLoading(false))
  };

  return (
    <Modal
      title={"Salary Scale Attachment"}
      visible={visible}
      onCancel={onCancel}
    >
      <Form
        form={form}
        onFinish={onFinish}
      >
        <Form.Item
          name="attachment"
          label={"Attachment"}
          rules={[
            {
              required: true,
              message: "Please upload file!",
            },
          ]}
        >
          <Dragger
            className={`ant-form-item ${attachmes.length ? "has-uploaded-file" : ""}`}
            customRequest={onUploadFile}
            multiple={false}
            onRemove={onRemoveFile}
            fileList={attachmes}
          >
            {
              attachmes.length === 0 &&
              <>
                <p className="ant-upload-drag-icon" style={{ marginBottom: 5 }}>
                  <PaperClipOutlined style={{ fontSize: 35 }} />
                </p>
                <p className="ant-upload-hint">
                  Click or drag file on this to upload
                </p>
              </>
            }
          </Dragger>
        </Form.Item>
        <div className="ant-modal-footer2">
          <Button
            className="btn-cancel"
            onClick={onCancel}
            disabled={loading}
          >
            {t("text_cancel")}
          </Button>
          <Button
            className="btn-save"
            type="primary"
            htmlType="submit"
            disabled={loading}
            loading={loading}
          >
            {t("text_submit")}
          </Button>
        </div>
      </Form>

    </Modal>

  );
}

export default forwardRef(AttachmentModal);
